<template>
  <div class="live-byte__wrapper">
    <a-icon
      :icon="$options.consts.ICON.FLASH_ICON"
      :width="16"
      :height="16"
      original
      class="live-byte__icon"
    />
    <div class="live-byte__content">
      <p class="live-byte__title text-medium">
        {{ title }}
      </p>
      <a-media
        v-if="image"
        :image="image"
        class="live-byte__image"
        @click-on-image="onOpenModal"
      />
      <div class="live-byte__source-and-time-container text-small">
        <div class="live-byte__source">
          <span
            v-if="isOriginTelegram"
            class="live-byte__source-text-exclusive"
          >
            investingLive Exclusive
          </span>
          <span v-else class="live-byte__source-text">{{ sourceName }}</span>
        </div>
        <div class="live-byte__time">
          <span class="live-byte__dot"></span>
          <span :key="timeRefreshKey" class="live-byte__time-text">
            {{ getTimeAgo() }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import AIcon, { ICON } from 'shared/AIcon'
import { LIVE_BYTES_ORIGIN } from '@/components/_layout/ASidebar/LiveBytes/enums'
import AMedia from 'shared/AMedia'

export default {
  name: 'LiveByte',
  components: { AIcon, AMedia },
  props: {
    title: propValidator([PROP_TYPES.STRING]),
    sourceName: propValidator([PROP_TYPES.STRING]),
    timeRefreshKey: propValidator([PROP_TYPES.STRING]),
    createdOn: propValidator([PROP_TYPES.STRING]),
    origin: propValidator([PROP_TYPES.STRING]),
    image: propValidator([PROP_TYPES.OBJECT], false)
  },
  consts: {
    ICON,
    LIVE_BYTES_ORIGIN
  },
  computed: {
    isOriginTelegram() {
      return this.origin === LIVE_BYTES_ORIGIN.TELEGRAM
    }
  },
  methods: {
    getTimeAgo() {
      const createdDate = new Date(this.createdOn)
      const secondsAgo = Math.floor((new Date() - createdDate) / 1000)

      if (secondsAgo < 5) return `just now`
      if (secondsAgo < 60) return `${secondsAgo}s ago`

      const minutesAgo = Math.floor(secondsAgo / 60)
      if (minutesAgo < 60) return `${minutesAgo}m ago`

      const hoursAgo = Math.floor(minutesAgo / 60)
      if (hoursAgo < 24) return `${hoursAgo}h ago`

      const daysAgo = Math.floor(hoursAgo / 24)
      return `${daysAgo}d ago`
    },
    onOpenModal() {
      this.$emit('open-image-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
.live-byte__wrapper {
  display: flex;
  padding: 0 0 10px;
}

.live-byte__content {
  width: 100%;
}

.live-byte__icon {
  margin: 6px 6px 6px 0;
}

.live-byte__title {
  margin-bottom: 6px;
}

.live-byte__image {
  width: 100%;
  margin-bottom: 6px;
  cursor: pointer;

  /deep/ .a-image__wrapper {
    border-radius: 4px;
  }
}

.live-byte__source-and-time-container {
  display: flex;
  align-items: center;
  align-content: center;
  align-self: stretch;
  flex-wrap: wrap;
}

.live-byte__source {
  display: flex;
  align-items: center;
}

.live-byte__time {
  display: flex;
  align-items: center;
}

.live-byte__source-label,
.live-byte__time {
  color: $c--gray;
}

.live-byte__source-label {
  white-space: nowrap;
  margin-right: 5px;
}

.live-byte__source-text {
  color: $c--gray-dark;
}

.live-byte__source-text-exclusive {
  display: flex;
  padding: 3px 5px;
  align-items: center;
  letter-spacing: -0.15px;
  color: $c--dark-purple;
  border-radius: 4px;
  background: $c--light-purple-2;
  font-weight: 400;
}

.live-byte__dot {
  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    background-color: $c--gray-dark;
    border-radius: 50%;
    opacity: 0.3;
    vertical-align: middle;
    margin: 0 6px 0 8px;
  }
}
</style>
